<template>
  <div style="width: auto" class="py-2">
    <section v-if="!isCollapsed" class="nfe-card pa-2 py-3">
      <v-card-text class="d-flex justify-space-between pa-0" style="font-size: 1rem">
        <div v-if="isLongText(unallocatedDelivery?.nameRecipient || '')">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate" v-bind="attrs" v-on="on">
                <span class="font-weight-bold">Destinatário: </span>
                <span :class="['font-weight-regular', { 'subtitle-2': isNameRecipientUppercase }]">
                  {{ truncateText(unallocatedDelivery?.nameRecipient) }}</span
                >
              </div>
            </template>
            <span>{{ unallocatedDelivery?.nameRecipient }}</span>
          </v-tooltip>
        </div>
        <div v-else class="text-truncate">
          <span class="font-weight-bold">Destinatário: </span>
          <span :class="['font-weight-regular', { 'subtitle-2': isNameRecipientUppercase }]">
            {{ unallocatedDelivery?.nameRecipient }}</span
          >
        </div>
        <div class="d-flex">
          <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
          <v-icon class="handle-drag" v-show="isDragable" size="24">mdi-drag</v-icon>
        </div>
      </v-card-text>
      <v-card-text class="d-flex pa-0 pt-3">
        <v-row>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold span-nfe text--secondary">CPF/CNPJ: </span>
            <span class="font-weight-regular span-nfe pr-2">
              {{ transformCpfOrCnpj(unallocatedDelivery?.cpfCnpjRecipient) }}</span
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="d-flex pa-0 pt-3" style="font-size: 1rem">
        <div v-if="isLongText(unallocatedDelivery?.nameSender || '')">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate" v-bind="attrs" v-on="on">
                <span class="font-weight-bold">Remetente: </span>
                <span :class="['font-weight-regular', { 'subtitle-2': isNameSenderUppercase }]">
                  {{ truncateText(unallocatedDelivery?.nameSender) }}</span
                >
              </div>
            </template>
            <span>{{ unallocatedDelivery?.nameSender }}</span>
          </v-tooltip>
        </div>
        <div v-else class="text-truncate">
          <span class="font-weight-bold">Remetente:</span>
          <span :class="['font-weight-regular', { 'subtitle-2': isNameSenderUppercase }]">
            {{ unallocatedDelivery?.nameSender }}</span
          >
        </div>
      </v-card-text>

      <v-card-text class="d-flex pa-0 py-3">
        <v-row>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold span-nfe text--secondary">CPF/CNPJ: </span>

            <v-tooltip v-if="hasMultipleCpfCnpj(unallocatedDelivery?.cpfCnpjSender)" bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="font-weight-regular span-nfe pr-2 text-truncate" v-bind="attrs" v-on="on">
                  {{ truncateText(transformCpfOrCnpj(unallocatedDelivery?.cpfCnpjSender)) }}</span
                >
              </template>
              <span>{{ unallocatedDelivery?.cpfCnpjSender }}</span>
            </v-tooltip>
            <span v-else class="font-weight-regular span-nfe pr-2">
              {{ transformCpfOrCnpj(unallocatedDelivery?.cpfCnpjSender) }}</span
            >
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="d-flex px-0 py-3">
        <v-row>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold text--secondary">Peso: </span>
            <span class="font-weight-regular pr-2">{{ formatWeight(unallocatedDelivery?.weightNfes) }}kg</span>
            <span class="font-weight-bold text--secondary">Preço: </span>
            <span class="font-weight-regular">{{ formatPrice(unallocatedDelivery?.totalPriceNfes) }}</span>
          </v-col>
          <v-col class="pa-0 pl-3" cols="12" md="12">
            <span class="font-weight-bold text--secondary">N° Entrega: </span>
            <span class="font-weight-regular">{{ unallocatedDelivery?.deliveryNumber }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </section>
    <section v-else class="nfe-card-collapsed pa-0 py-1 ">
      <v-card-text class="w-100 d-flex justify-space-between pa-0 " style="font-size: 0.95rem;">
        <v-col class="pa-0 pl-2 align-self-center" cols="auto">
          <span class="font-weight-regular text--secondary">N° Entrega: </span>
          <span class="font-weight-medium ">{{ unallocatedDelivery?.deliveryNumber }}</span>
        </v-col>
        <v-col class="d-flex pa-0 pl-3" cols="auto">
          <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
          <v-icon class="handle-drag" v-show="isDragable" size="24">mdi-drag</v-icon>
        </v-col>
      </v-card-text>
    </section>
  </div>
</template>

<script>
import copyToClipboard from '@/utils/copyToClipboard';
import maskPrice from '@/utils/maskPrice';
import maskWeight from '@/utils/maskWeight';
import maskCPF from '@/utils/maskCPF';
import maskCNPJ from '@/utils/maskCNPJ';

export default {
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    },
    unallocatedDelivery: {
      type: Object,
      default: () => {}
    },
    selected: {
      type: Boolean,
      default: false
    },
    isDragable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localSelected: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('update:selected', value);
      }
    },
    isNameRecipientUppercase() {
      return this.unallocatedDelivery?.nameRecipient === this.unallocatedDelivery?.nameRecipient.toUpperCase();
    },
    isNameSenderUppercase() {
      return this.unallocatedDelivery?.nameSender === this.unallocatedDelivery?.nameSender.toUpperCase();
    }
  },
  methods: {
    copy(str) {
      copyToClipboard(str);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    },
    isLongText(text, limit = 20) {
      return text.length > limit;
    },
    truncateText(text, limit = 20) {
      return text.length > limit ? text.substring(0, limit - 3) + '...' : text;
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    hasMultipleCpfCnpj(cpfCnpj) {
      return cpfCnpj.includes(',');
    }
  }
};
</script>

<style scoped>
* {
  transition: 0ms;
}
.span-nfe {
  font-size: 13px;
}
.nfe-card {
  width: 350px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.nfe-card-collapsed {
  width: 220px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.checkbox-nfe {
  margin-top: 2px;
}
::v-deep .checkbox-nfe .v-input--selection-controls__input {
  margin-right: 0px;
}
</style>
